import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ChannelTemplateCategory } from "../../../domain/channel-template-category";
import { ChannelTemplateRepository } from "../../../domain/channel-template-repository";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Subject } from "rxjs";
import { ChannelTemplate } from "../../../domain/channel-template";
import { SessionStorageService } from "../../../services/session-storage.service";
import {
  RequestDemoData,
  TenantRepository,
} from "../../../domain/tenant-repository";
import { UI } from "../../../services/ui.service";

@Component({
  selector: "choose-template",
  templateUrl: "./choose-template.component.html",
  styleUrls: ["./choose-template.component.scss"],
})
export class ChooseTemplateComponent implements OnInit {
  templateCategories: Array<ChannelTemplateCategory> = [];
  currentCategory: ChannelTemplateCategory;
  allTemplates: Array<ChannelTemplate>;
  templates: Array<ChannelTemplate>;
  templateTitleFilter: string;
  chosenTemplate: ChannelTemplate;
  requestDemoFilledData: RequestDemoData;

  showPreloader: boolean = false;
  channelName: string = "";

  constructor(
    private channelTemplateRepository: ChannelTemplateRepository,
    private router: Router,
    private UI: UI,
    private route: ActivatedRoute,
    private sessionStorageService: SessionStorageService,
    private tenantRepository: TenantRepository,
  ) {
    this.channelTemplateRepository
      .getAllChannelTemplateCategories()
      .then((categories) => {
        this.templateCategories = categories;
      });

    this.channelTemplateRepository.getAllTemplates().then((templates) => {
      this.templates = this.allTemplates = templates;
    });
  }

  ngOnInit() {
    //check if the user has filled the request a demo form,
    if (this.checkIfFilledCreateTenantForm() == false) {
      this.router.navigateByUrl("/tenant/request-demo");
    }
    this.requestDemoFilledData = JSON.parse(
      this.sessionStorageService.getItem("requestDemoTenantData"),
    );

    this.route.queryParams.subscribe((params: Params) => {
      let paramCategoryIdParam: string = params["categoryId"];
      this.handleFilterByCategory(parseInt(paramCategoryIdParam), params);

      let searchTemplateByTitleParam: string = params["searchTitle"];
      this.handleFilterByTitle(searchTemplateByTitleParam);
    });
  }

  private handleFilterByTitle(searchTitleFilter: string) {
    if (searchTitleFilter != null) {
      //this.templates = this.allTemplates.filter(template => template.title.toLocaleLowerCase().trim().includes(searchTitleFilter.toLocaleLowerCase().trim()));
      this.templateTitleFilter = searchTitleFilter;
    }
  }

  private handleFilterByCategory(paramCategoryId: number, params: Params) {
    if (!paramCategoryId) {
      this.currentCategory = null;
      this.templates = this.allTemplates;
      return;
    }
    //validate if the category exists
    let paramCategoryObj = this.templateCategories.find(
      (category) => category.id == paramCategoryId,
    );
    if (paramCategoryObj) {
      this.currentCategory = paramCategoryObj;

      this.templates = this.allTemplates.filter((template) =>
        template.categories.find((cat) => cat.id == paramCategoryObj.id),
      );
    } else {
      delete params["categoryId"];
      this.router.navigate(["tenant/choose-template"], {
        relativeTo: this.route,
        queryParams: params,
      });
    }
  }

  redirectToCategory(category: ChannelTemplateCategory) {
    console.log(
      "ChooseTemplateSideMenuComponent: categoryClickedHandler",
      category,
    );
  }

  private checkIfFilledCreateTenantForm(): boolean {
    return this.sessionStorageService.getItem("requestDemoTenantData") != null;
  }

  templateChoosen(chosenTemplate: ChannelTemplate) {
    console.log("templateChoosen ", chosenTemplate);
    this.chosenTemplate = chosenTemplate;
    this.showPreloader = true;
  }

  createNewTenantAndTrialUserFromTemplate(channelName: string) {
    this.channelName = channelName;
    if (this.channelName) {
      this.tenantRepository
        .createNewTenantAndTrialUserFromTemplate(
          this.chosenTemplate.id,
          this.channelName,
          true,
          this.requestDemoFilledData,
        )
        .then((result) => {
          this.sessionStorageService.removeItem("requestDemoTenantData");
          this.router.navigateByUrl("tenant/success-window");
        })
        .catch((error) => {
          this.UI.notify(this.UI.EVENTS.ShowAlert, {
            title: "Create new User and Channel",
            message: "Failed to create the user!",
          });
          this.showPreloader = false;
          this.channelName = "";
          console.log(error);
        });
    } else {
      this.showPreloader = false;
    }
  }
}
